;(function() {
/* @ngInject */
function ZmenaZivnostiObjednaneController(CompletedOrderService, $window, $filter, Helpers, SigniService){
  let vm = this;
  let server = CompletedOrderService;

  vm.generateDocs = generateDocs;
  vm.getFileName = Helpers.getFileName;
  vm.payment = "movement";
  vm.showMovement = false;
  vm.isUnzipFiles = true;
  vm.showLoading = false;
  vm.hideDownloadDocuments = true;
  vm.downloadLabel = $filter("translate")('payments.documents.general');

  server.getCompletedOrderData().then(onPaymentInfoLoad);

  SigniService.handleSigniResponse();

  let dataLayerStorage = $window.localStorage.getItem('dataLayer');
  $window.localStorage.removeItem('dataLayer');
  var dataLayer = $window.dataLayer = $window.dataLayer || [];
  if (dataLayerStorage)
    dataLayer.push(JSON.parse(dataLayerStorage));

  function onPaymentInfoLoad(payment) {
    if(payment) {
      vm.orderId = payment.orderId;
      vm.price = payment.price;
      vm.paymentData = payment;
      vm.hideDownloadDocuments = payment.hideDownloadDocuments;
    } else {
      $window.location = "krok1";
    }
  }

  function generateDocs() {
    vm.showLoading = true;
    server.regenerateDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }
}

angular.module("firmaren")
  .controller("ZmenaZivnostiObjednaneController", ZmenaZivnostiObjednaneController);
}());
